module.exports = __webpack_public_path__ + "static/media/ow2ll13.83856523.png";